export const GET_VIRTUAL_FARM_DETAILS_REQUEST = "GET_FARM_DETAILS_REQUEST";
export const GET_VIRTUAL_FARM_DETAILS_REQUEST_SUCCESS =
  "GET_VIRTUAL_FARM_DETAILS_REQUEST_SUCCESS";
export const AGE_SELECTED = "AGE_SELECTED";
export const GET_VIRTUAL_FARM_DETAILS_REQUEST_ERROR =
  "GET_VIRTUAL_FARM_DETAILS_REQUEST_ERROR";
export const UPDATE_COW_POLL_INFO = "UPDATE_COW_POLL_INFO";
export const RESET_AGE_SELECTION = "RESET_AGE_SELECTION";
